export const searchTypes: Record<string, string> = {
  project: 'โครงการ',
  zone: 'ทำเล-ย่าน',
  district: 'เขต',
  road: 'ถนน',
  bts: 'bts',
  arl: 'arl',
  city: 'city',
  metro_station: 'รถไฟฟ้า',
  'airport-link': 'arl',
};
